<template>
    <section feature-content v-editable="blok" :id="sectionId" :data-style="blok?.style || 'default'" :data-spacing="blok?.spacing || 'default'">
        <div class="container">
            <div class="section-row">
                <label class="section-header" v-if="blok.section" v-text="blok.section"></label>
                <h2 class="section-title"  v-if="blok.title && title != ''" v-html="title"></h2>
                <div class="section-description"  v-if="blok.description && description != ''">
                    <Vue3RuntimeTemplate :template="description" />
                </div>
                <div class="section-content"  v-if="blok.content && content != ''">
                    <Vue3RuntimeTemplate :template="content" />
                </div>
            </div>
        </div>
    </section>
</template>
<style src="~/assets/scss/section/feature-content.scss" lang="scss"></style>
<script setup>
import Vue3RuntimeTemplate from "vue3-runtime-template";
const props = defineProps({ blok: Object });
const title = computed(() => useRichText(props?.blok?.title || {}));
const description = computed(() => useRichText(props?.blok?.description || {}));
const content = computed(() => useRenderRichText(props?.blok?.content || {}));
const sectionId = computed(() => {
    if(props.blok?.section) return textSlugify(props.blok?.section);
    return props.blok?._uid;
})
</script>